// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Types__Common = require("../Types__Common.bs.js");

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return Types__Common.RentalPropertyType.toString(x.value);
}

function make(value) {
  return {
    value: value,
    label: Types__Common.RentalPropertyType.toDisplayString(value)
  };
}

let defaultValues = [
  "CONDO",
  "SINGLE_FAMILY"
];

let defaultOptions = defaultValues.map(make);

exports.getOptionLabel = getOptionLabel;
exports.getOptionValue = getOptionValue;
exports.make = make;
exports.defaultValues = defaultValues;
exports.defaultOptions = defaultOptions;
/* defaultOptions Not a pure module */
